import React from "react"
import Layout from "../components/layout"
import Seo from "../components/seo"

const ScreeningForm = () => (
  <Layout>
    <Seo
      title="Visitor Screening Form - Assured Assisted Living"
      description="Staff must be sent home immediately if answering yes.  Additionally, everyone must be fever-free (without medication) for 72 hours and have a negative COVID test."
    />
    <div className="page-headline blog-page">
      <div className="container">
        <div className="section-heading text-center">
          <h1>Visitor Screening Form - Assured Assisted Living</h1>
        </div>
      </div>
    </div>
    <div className="page-content menu">
      <div className="container">
        <div className="row justify-content-between">
          <div className="col-md-12 m-auto iframe-wrap-form">
            <iframe
              title="docformsframe"
              src="https://docs.google.com/forms/d/e/1FAIpQLSeXv82_2btnd1ajv4Rp_gz9SnJ6SY0HHWzPie5cdD4-9obrRQ/viewform"
              frameborder="0"
            ></iframe>
          </div>
        </div>
      </div>
    </div>
  </Layout>
)

export default ScreeningForm
